<template>
  <div class="registerBox">
    <auth-logo />

    <van-tabs @click="onClick" v-model="active" class="loginTabs" animated>
      <van-tab :title="$t.loginInterpret.login"></van-tab>
      <van-tab :title="$t.registerInterpret.register"></van-tab>
    </van-tabs>

    <!-- 表单 -->
    <div class="formBox">
      <div class="inputBox">
        <input class="email" v-model="auth.email" type="text" :placeholder="$t.registerInterpret.inputEmail" />
      </div>
      <div class="inputBox">
        <input class="code" v-model="auth.code" type="text" :placeholder="$t.registerInterpret.inputCode" />
        <button class="getCode" v-if="isShowCode" @click="verifyEmail">
          {{ $t.registerInterpret.code }}
        </button>
        <div class="codeInfo" v-else>{{ timerNum }}S</div>
      </div>
      <div class="next" @click="next">{{ $t.registerInterpret.next }}</div>
      <div class="classHome">
        <div class="termsTitle">
          <van-checkbox v-model="checked" checked-color="#0090e6" icon-size="20px"></van-checkbox>
          <div @click="goTerms" class="termsText">
            {{ $t.registerInterpret.rulesAndProtocols }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AuthLogo from "./components/AuthLogo";
import { Tab, Tabs, Checkbox } from "vant";
import Vue from "vue";

Vue.use(Tab).use(Tabs).use(Checkbox);
export default {
  name: "Register",
  components: {
    AuthLogo,
  },
  data() {
    return {
      active: 1,
      checked: false,
      isShowCode: true, //实收显示获取验证码
      timerNum: 0,
      timerItem: null, //定时器对象
      auth: {
        code: "",
        email: "",
      },
      inviteCode: "", //邀请码
    };
  },
  mounted() {
    const { InviteCode } = this.$route.query;
    if (InviteCode) {
      this.inviteCode = InviteCode;
    }
  },
  methods: {
    onClick(index) {
      if (index == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: false,
          path: "auth/login",
          name: "Login",
          query: [],
        });
      }
    },
    goTerms() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "terms",
        name: "Terms",
        query: [],
      });
    },
    verifyEmail() {
      this.$commonMethod.showLoading();
      let param = {
        Email: this.auth.email,
      };
      this.$api.system
        .sendEmailCode(param)
        .then((res) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(
            this.$commonEnv.actionType.showNotify,
            {
              titleMsg: this.$t.registerInterpret.verificationCodeInfo,
              type: "success",
            }
          );
          //启动定时器
          this.timerTime();
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(
            this.$commonEnv.actionType.showNotify,
            {
              titleMsg: err.message,
              type: "danger",
            }
          );
        });
    },
    //定时器
    timerTime() {
      this.timerNum = 120;
      this.isShowCode = false;
      this.timerItem = setInterval(() => {
        this.timerNum--;
        if (this.timerNum < 1) {
          clearInterval(this.timerItem);
          this.isShowCode = true;
        }
      }, 1000);
    },
    //下一步
    next() {
      if (!this.checked) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg:
            this.$t.registerInterpret.tick +
            this.$t.registerInterpret.rulesAndProtocols,
        });
        return false;
      }
      const { code, email } = this.auth;
      if (email === "" || code === "") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.registerInterpret.verificationCodeError,
          type: "danger",
        });
        return false;
      }
      let param = {
        Email: email,
        AuthCode: code,
      };
      this.$api.system
        .checkAuthCode(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          setTimeout(() => {
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.routerPush,
              {
                isParams: true,
                path: "auth/regInfo",
                name: "RegInfo",
                query: [
                  {
                    name: "AuthCode",
                    value: param.AuthCode,
                  },
                  {
                    name: "Email",
                    value: param.Email,
                  },
                  {
                    name: "InviteCode",
                    value: this.inviteCode,
                  },
                ],
              }
            );
          }, 1000);
        })
        .catch((err) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
  },
  destroyed() {
    clearInterval(this.timerItem);
    this.timerItem = null;
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";

.registerBox {
  position: relative;
  width: 100%;

  .loginTabs {
    ::v-deep .van-tabs__nav {
      background: rgba(0, 0, 0, 0.1);
    }

    ::v-deep .van-tabs__wrap {
      width: 60%;
      border-radius: 10rem;
      margin: auto;
    }

    ::v-deep .van-tab {
      color: #fff;
      font-weight: bold;
    }

    ::v-deep .van-tab--active {
      border-radius: 10rem;
      background: #fff;
      color: #0090e6;
    }

    ::v-deep .van-hairline--top-bottom::after {
      display: none;
    }

    ::v-deep .van-tabs__line {
      display: none;
    }

    ::v-deep .van-tab__text {
      font-size: 1rem;
      line-height: 2;
      overflow: visible;
    }
  }

  //表单
  .formBox {
    width: 85%;
    position: relative;
    margin: 0 auto;
    margin-top: 2rem;

    .formTitle {
      width: 190px;
      border-radius: 50px;
      background-color: #ffffff;
      color: #0090e6;
      height: 24px;
      font-size: 26px;
      text-align: center;
      height: 70px;
      line-height: 70px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
    }

    .inputBox {
      @include publicFlex;
      justify-content: space-between;
      align-items: center;
      margin-top: 18px;
      width: 100%;

      .code,
      .email {
        background: none;
        outline: none;
        border: none;
        -webkit-appearance: none;
        /*去除系统默认的样式*/
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        /* 点击高亮的颜色*/
        color: #f3faf8;
        font-size: 14px;
        width: 100%;
        line-height: 40px;
        border: 2px solid #ffffff;
        border-radius: 100px;
        padding: 0 1.5rem;
        box-sizing: border-box;

        &::placeholder {
          color: #f3faf8;
          font-size: 14px;
        }

        &::-webkit-input-placeholder {
          color: #f3faf8;
          font-size: 14px;
        }
      }

      .getCode,
      .codeInfo {
        outline: none;
        border: 0;
        height: 50px;
        width: 185px;
        background-color: #ffffff;
        color: #0090e6;
        font-size: 14px;
        text-align: center;
        border-radius: 80px;
        overflow: hidden;
        margin-left: 5%;
      }

      .codeInfo {
        font-size: 14px;
        line-height: 50px;
        background-color: #dcdcdc;
        color: #ffffff;
      }
    }

    .next {
      width: 100%;
      border-radius: 50px;
      line-height: 50px;
      text-align: center;
      color: #0090e6;
      font-size: 16px;
      font-weight: bold;
      background-color: #f3faf8;
      margin-top: 20px;
    }

    .InvitationCode {
      margin-top: 20px;
      font-size: 24px;
      width: 100%;
      height: 96px;
      line-height: 96px;
      border: 1px solid #25B9FF;
      border-radius: 100px;
      padding: 0 47px;
      box-sizing: border-box;
      color: #000000;
      color: rgba(0, 0, 0, 1);
      font-size: 30px;
      font-family: Helvetica;
      font-weight: 400;
      opacity: 0.3;
    }

    .classHome {
      text-decoration: none;
      text-align: center;
      margin-top: 25px;

      &:link,
      :visited,
      :hover,
      :active {
        text-decoration: none;
      }

      .termsTitle {
        margin-top: 25px;
        font-size: 14px;
        color: #ffffff;

        .van-checkbox {
          width: 10%;
          display: inline-block;
          vertical-align: middle;

          ::v-deep .van-checkbox__label {
            color: #ffffff;
          }
        }

        .termsText {
          color: #e5e5e5;
          width: 90%;
          display: inline-block;
          text-align: left;
          vertical-align: middle;
        }
      }
    }

    .forget {
      margin-top: 25px;
      color: #ffffff;
      text-align: center;
      font-size: 14px;
    }
  }
}
</style>
